<template>
	<div>
		<!-- Net Premium -->
		<j-list :list="computedNetPremium">
			<div class="flex xs-12 p3 bg7--l4 bc7 bt1" slot="list" slot-scope="{ item }">
				<div class="flex xs-6 xs-left xs-middle fw7 c1 lh125">
					{{ item.label }}
					<j-button
						v-if="hasPremiumActions"
						v-can:or="['writeQuotes', 'writePolicies']"
						size="xsmall"
						class="ml2"
						type="fifth"
						@click="$modal.show(`edit_net_premium_${id}`)"
					>{{ $t("edit_net_premium") }}</j-button>
					<j-button
						v-if="hasPremiumActions"
						v-can:or="['writeQuotes', 'writePolicies']"
						size="xsmall"
						class="ml2"
						type="fifth"
						@click="$emit('premium:reset')"
					>{{ $t("reset") }}</j-button>
				</div>
				<div class="flex xs-6 xs-right xs-middle lh125 fw7">{{ item.value }}</div>
			</div>
		</j-list>

		<core-modal
			:name="`edit_net_premium_${id}`"
			:headline="$t('edit_net_premium')"
		>
			<div class="p4">
				<div class="lh150">
					<div class="lh150">
						<span class>{{ $t("edit_net_premium_description") }}</span>
						<p
							class="pt2 pb2"
						>{{ $t("net_premium") }}: {{ computedNetPremium[0].value }}</p>
					</div>
				</div>
				<update-premium
					type="net"
					:isLoading="isLoading"
					:amount="netPremium"
					@created="onUpdatePremium"
					@cancelled="$modal.hide(`edit_net_premium_${id}`)"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import JList from "@/components/JList"
import JButton from "@/components/JButton"

import UpdatePremium from "./UpdatePremium"

export default {
	components: {
		CoreModal,
		JList,
		JButton,
		UpdatePremium
	},
	props: {
		id: {
			type: String
		},
		pricing: {
			type: Object
		},
		hasPremiumActions: {
			type: Boolean
		},
		onUpdatePremium: {
			type: Function
		},
		isLoading: {
			type: Boolean
		}
	},
	computed: {
		netPremium() {
			return this.pricing.amount
		},
		computedNetPremium() {
			return [
				{
					label: this.$t("net_premium"),
					value: this.pricing?.formattedPrice
				}
			]
		}
	}
}
</script>

<style>
</style>